import React from 'react'

function Dogovor() {
    return (
<section className="form">
  <div className="container">
    <div className="form-inner">
      <div className="form-text">
        <img src="https://www.flaticon.com/svg/vstatic/svg/564/564619.svg?token=exp=1615018971~hmac=ff6a4cd841c3c8bd5810d442d5517e5d" alt />
        <h2>КАКУЮ ЛИЦЕНЗИЮ ВЫБРАТЬ?</h2>
      </div>
      <div className="container-form">
        <h1>Заполните форму, мы свяжемся с вами индивидуально<br /> в Instagram или WhatsApp<br />или можете нам написать на нашу почту,<br />что бы договориться на счёт заказа<br />для создание сайта</h1>
        <button><span className="form-text-btn">Написать нам</span></button>
      </div>
    </div>
  </div>
</section>

    )
}

export default Dogovor
